module.exports = __webpack_public_path__ + "img/competencies_rd_swiper_03.1b447e46.jpg";